import type { Marker } from '@googlemaps/markerclusterer';
import React, { useCallback, useState } from 'react';
import {
  AdvancedMarker,
  AdvancedMarkerAnchorPoint,
} from '@vis.gl/react-google-maps';
import { toLatlng } from '../../util/MapUtil';
import { useMapContext } from '../../contexts/MapContext/MapContext';
import { MapIcon, ModuleConfig } from '@schamburg-web/interfaces';

export type GoogleClusteredMarkerProps = {
  iconObj: MapIcon;
  module: ModuleConfig;
  setMarkerRef: (marker: Marker | null, key: string) => void;
};

/**
 * Wrapper Component for an AdvancedMarker for a single tree.
 */
export const GoogleClusteredMarker = (props: GoogleClusteredMarkerProps) => {
  const { iconObj, module, setMarkerRef } = props;
  const { selectedMarker, setSelectedMapIcon } = useMapContext();
  const myMarker = module.displayConfig?.markerDef || null;
  const [myMarkerRef, setMyMarkerRef] =
    useState<google.maps.marker.AdvancedMarkerElement | null>(null);
  // Callback to set the marker reference and handle click events
  // This is used to ensure the marker reference is set correctly
  // and to handle the click event to select the marker.
  const ref = useCallback(
    (marker: google.maps.marker.AdvancedMarkerElement) => {
      setMyMarkerRef(marker);
      setMarkerRef(marker, iconObj.id);
    },

    [setMarkerRef, iconObj]
  );

  return (
    <AdvancedMarker
      anchorPoint={AdvancedMarkerAnchorPoint.CENTER}
      position={toLatlng(iconObj)}
      ref={ref}
      onClick={() => {
        if (null === selectedMarker) {
          setSelectedMapIcon({ icon: iconObj, module: module }, myMarkerRef);
        } else {
          setSelectedMapIcon(null, null);
          setTimeout(() => {
            setSelectedMapIcon({ icon: iconObj, module: module }, myMarkerRef);
          }, 100);
        }
      }}
    >
      {myMarker &&
        typeof myMarker === 'function' &&
        React.createElement(myMarker, {
          icon: iconObj,
          key: iconObj.id,
          module: module,
        })}
    </AdvancedMarker>
  );
};
